<template>
  <div class="container">
    <div class="scroll_container">
      <div class="info" style="display: flex; flex-direction: row">
        <div class="align-vertical flex_1 h_center">
          <div class="align-vertical">
            <span class="name">{{ myinfo.name }}</span>
            <span class="phone">{{ u.formatPhoneNumber(myinfo.phone) }}</span>
            <div class="align-horizontal day mt-1" v-if="self.myinfo.setting.ticket_price === 'F' || self.myinfo.setting.ticket_show === 'Y'">
              <span v-if="self.myinfo.setting.ticket_price === 'F'">{{ut.format($t('more.days_left'), '∞')}}</span>
              <div v-else>
                <span class="mr-1" v-if="diffDays > 0" >{{ut.format($t('more.days_left'), diffDays)}}</span>
              </div>
<!--              <b-button class="extend_btn"
                        variant="white"
                        @click="(e) => {self.showExtendPopup = true;
                         }"
                        v-if="self.myinfo.setting.ticket_show === 'Y'">
                <span class="extend_btn_text">{{$t('more.extends')}}</span>
              </b-button>-->
            </div>
            <span class="day mt-1"> {{ut.format($t('more.points_remain'), u.currency(Math.max(0, self.myinfo.point)))}}</span>
          </div>
        </div>
        <div class="align-horizontal flex_1 center">
          <div class="business_card" style="display: flex; align-items: center;">
            <span class="business_card_label" v-if="self.myinfo.businessCard == ''">{{$t('signup_info.business_card_photo')}}</span>
            <b-img v-else :src="self.myinfo.businessCard" class="full"/>
          </div>
        </div>
      </div>
      <div class="row">
        <a class="col" @click="() => {
          eventBus.$emit('checkTicketAvailable', ()=>{
            this.showNotifyWritePopup = true;
            this.$store.commit('setIsAutoPage', false);
          })
        }">
          <img src="../../../../assets/image/ic_noti_send@2x.png" class="col_icon" >
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.send_noti')}}</span>
          </div>
        </a>
        <a class="col" @click="$store.commit('setSiteForNotifyList', null);$store.commit('setNotifyTabIndex', $c.NOTIFY_TAB.MODIFY); $router.push('notify')">
          <img src="../../../../assets/image/ic_noti_modify@2x.png" class="col_icon" >
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.noti_modify')}}</span>
          </div>
        </a>
        <a class="col"
                     @click="$store.commit('setNotifyTabIndex', $c.NOTIFY_TAB.AUTO); $router.push('notify')">
          <img src="../../../../assets/image/ic_noti_auto@2x.png" class="col_icon">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.auto_noti')}}</span>
          </div>
        </a>
      </div>
      <div class="row">
        <a class="col" @click="showSaleRegisterPopup = true">
          <img src="../../../../assets/image/ic_sale_regist@2x.png" class="col_icon" style="height: 40px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.sale_regist')}}</span>
          </div>
        </a>
        <a @click="() => {$store.commit('setTmpTabIndex', ''); $router.push('/SaleList')}" class="col">
          <img src="../../../../assets/image/ic_sale_list@2x.png" class="col_icon" style="height: 52px">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.sale_list')}}</span>
          </div>
        </a>
        <a class="col" @click="showTransferSalePopup=true">
          <img src="../../../../assets/image/ic_sale_trans@2x.png" class="col_icon" style="height: 40px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('map.transfer_site')}}</span>
          </div>
        </a>
      </div>
      <div class="row">
<!--        <a class="col" v-b-modal.modal-area-calc>
          <img src="../../../../assets/image/ic_square@2x.png" class="col_icon" style="height: 40px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.area_calc')}}</span>
          </div>
        </a>-->
        <a class="col" @click="showLoanCalcPopup = true">
          <img src="../../../../assets/image/ic_calculator@2x.png" class="col_icon" style="height: 40px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.loan_calc')}}</span>
          </div>
        </a>
        <a class="col" @click="onTransport">
          <img src="../../../../assets/image/ic_transport@2x.png" class="col_icon" style="height: 35px">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.nearby_transport')}}</span>
          </div>
        </a>
        <a class="col" @click="$router.push('inquire')">
          <img src="../../../../assets/image/ic_inquire@2x.png" class="col_icon" style="height: 52px;bottom: 56px">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.inquire')}}</span>
          </div>
        </a>
      </div>
      <div class="row" style="border-bottom-style: none;">
        <a class="col" @click="showExtendPopup= true">
          <img src="../../../../assets/image/ic_use_time.png" class="col_icon" style="height: 30px;;margin-bottom: 8px">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.usage_extension')}}</span>
          </div>
        </a>
        <a class="col" @click="showChargePointPopup= true">
          <img src="../../../../assets/image/ic_charge@2x.png" class="col_icon" style="height: 45px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.point_charging')}}</span>
          </div>
        </a>
        <a class="col" @click="showSettingPopup = true">
          <img src="../../../../assets/image/ic_setting@2x.png" class="col_icon" style="height: 45px;">
          <div class="col_text_wrapper">
            <span class="col_text">{{$t('more.setting')}}</span>
          </div>
        </a>
      </div>

    </div>
    <Navbar />
    <LoanCalcPopup
      :visible.sync="showLoanCalcPopup"/>

    <TermPopup :visible.sync="showTermPopup"
               :title="title"
               :content="content" />
    <b-modal id="modal-area-calc" style="width:500px;"
             hide-footer
             body-class= "confirm-body"
             header-class="popup_header1"
             @hidden="area_pyong = ''; area_sqm ='';"
             centered>
      <template #modal-title>
        <span class="dlg_title1">
          {{$t('more.area_calc')}}
        </span>
        <b-button class="input_reset_wrapper" @click="area_sqm=''; area_pyong='';">
          <span class="input_reset">{{$t('common.reset')}}</span>
        </b-button>
      </template>
      <template #modal-header-close>
        <b-img class="dlg_close_btn" :src="require('../../../../assets/image/ic_close2.png')"/>
      </template>
      <div class="body" style="height: 120px;">
        <b-input v-model="area_sqm" type="number" class="input input_wrapper" @focus="sqm = true"/>
        <span style="font-weight: bold;" class="unit">㎡</span>
        <img src="../../../../assets/image/ic_arrow_gray_both.png" style="height: fit-content; margin: 0 10px; width: 25px;">
          <b-input v-model="area_pyong"  type="number" class="input input_wrapper" @focus="sqm = false"/>
        <span class="unit">{{$t('room_info_popup.pyong')}}</span>
      </div>
    </b-modal>

    <SiteRegisterPopup :visible.sync="showSaleRegisterPopup" />
    <SiteSelectPopup :visible.sync="showTransferSalePopup"
                     @onCancel="u.setState(self, {
                       showTransferSalePopup: false,
                     })"
                     @select="console.log('dfasdfasdfasdf')"
                     :type="SITE_SELECT.TRANSFER" />
    <SetSaleCompletePopup :visible.sync="showSetSaleCompletePopup"
                          :site_idx="selected_complete_site_idx"
                          @onCancel="u.setState(self, {
                            // showSetSaleCompletePopup: false,
                            selected_complete_site_idx: -1
                          })" />
    <ChargePointPopup
      v-if="showChargePointPopup"
      :visible.sync="showChargePointPopup"
    />
    <SettingPopup
      :visible.sync="showSettingPopup"
    />
    <UsageExtendPopup
      :visible.sync="showExtendPopup"
      :show-point-charge.sync="showChargePointPopup"
      @onCharge="usageDate = self.myinfo.usageDate" />
    <NotifyWritePopup
      :visible.sync="showNotifyWritePopup"/>
  </div>
</template>

<script>
import Navbar from "../../../controls/navbar";
import InputHasUnit from "../../../controls/InputHasUnit";
import ChargePointPopup from "../../../controls/popup/ChargePointPopup";
import SettingPopup from "../../../controls/popup/SettingPopup";
import Utils from "../../../../config/utils";
import LoanCalcPopup from "../../../controls/popup/LoanCalcPopup";
import moment from "moment";
import SiteSelectPopup from "../../../controls/popup/SiteSelectPopup";
import {SITE_SELECT} from "../../../controls/popup/SiteSelectPopup"
import SetSaleCompletePopup from "../../../controls/popup/SetSaleCompletePopup";
import UsageExtendPopup from "../../../controls/popup/UsageExtendPopup";
import TermPopup from "../../../controls/popup/TermPopup";

import NotifyWritePopup from "../../../controls/popup/NotifyWritePopup";
import SiteRegisterPopup from "../../../controls/popup/SiteRegisterPopup";
const util = require('util');
export default {
  name: "More",
  components: {
    SiteRegisterPopup,
    TermPopup,
    UsageExtendPopup,
    SetSaleCompletePopup,
    SiteSelectPopup,
    InputHasUnit,
    Navbar,
    ChargePointPopup,
    SettingPopup,
    LoanCalcPopup,
    NotifyWritePopup
  },
  inject: ["eventBus"],
  methods: {
    getAppInfo(){
      Utils.requestPost(
        this.$c.API.Auth.getAppInfo,
        {}
      ).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.saveSetting(result.data);
        }
      });
    },
    getHomeData: function () {
      Utils.requestGet(this.$c.API.User.getHomeData, {}, false).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.placeholder = result.data.home_setting.f_home_search_hint;
          this.homeSetting = result.data.home_setting;
          this.adsList = result.data.ads;
          this.siteList = result.data.interest_sites;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onHomeLink: function() {
      let homeSetting = this.homeSetting;
      switch (homeSetting.f_home_link_type) {
        case 'S':
          this.go2SiteDetail(homeSetting.f_home_link_data);
          break;
        case 'C':
          Utils.requestGet(this.$c.API.Community.getCommunityDetail, {
            community_idx: homeSetting.f_home_link_data,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.community = result.data;
              this.showCommunityDetailPopup = true;
            } else {
              Utils.toast(this, result.msg);
            }
          });
          break;
        case 'I':
          if (!homeSetting.f_home_link_data.startsWith('http')) {
            homeSetting.f_home_link_data = 'http://' + homeSetting.f_home_link_data;
          }
          this.imgList = [homeSetting.f_home_link_data];
          this.showGallery = true;
          break;
        case 'L':
          if (!homeSetting.f_home_link_data.startsWith('http')) {
            homeSetting.f_home_link_data = 'http://' + homeSetting.f_home_link_data;
          }
          // TODO:
          window.open(homeSetting.f_home_link_data,'_blank');
          break;
      }
    },
    go2SiteDetail(siteIdx){
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.siteDetailData = result.data;
          this.showSiteDetailPopup = true;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(async result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onTransport() {
       window.open('https://map.kakao.com/?', '_blank');
    },
  },
  watch:{
    area_sqm(){
      if (this.sqm)
        this.area_pyong = this.area_sqm == '' ? '' : Utils.calcPyong(this.area_sqm);
    },
    area_pyong(){
      if (!this.sqm)
        this.area_sqm = this.area_pyong == '' ? '' : Utils.calcSquare(this.area_pyong);
    },

  },
  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.MORE);
    this.$store.commit('setTodayNotifyList', false);
    this.getProfile();
    this.getHomeData();
    this.getAppInfo();
  },
  data() {
    return {
      u: Utils,
      ut: util,
      console: console,
      self: this,
      SITE_SELECT: SITE_SELECT,
      homeSetting: {},
      showExtendPopup: false,
      showSendNotifyPopup: false,
      showTransferSalePopup: false,
      showSaleRegisterPopup: false,
      showCompleteSalePopup: false,
      selected_complete_site_idx: -1,
      showSetSaleCompletePopup: false,
      showAreaCalcPopup: false,
      showLoadCalcPopup: false,
      showSettingPopup: false,
      showChargePointPopup: false,
      showTermPopup: false,
      showLoanCalcPopup:false,
      showNotifyWritePopup:false,
      sqm:true,
      title: '',
      content: '',
      newNotify: false,
      area_sqm: '',
      area_pyong: '',
      usageDate: this.myinfo.usageDate,
    }
  },
  computed: {
    diffDays() {
      let usage_date = moment(this.usageDate);
      if (usage_date.isValid()) {
        return usage_date.diff(moment(), 'd');
      }
      return 0;
    },
    format_unit() {
      return util.format(this.$t('map.month'), '');
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/main/more/More";
  div.scroll_container {
    padding-bottom: 69px;
    overflow: auto;
  }
  /**
  This style is for area calculation modal.
   */
  .unit{
    color: $black;
    font-size: 30px;
    font-family: $korean_gd_15_r;
    margin-left: 8px;
  }

  .input {
    text-align: center;
    color: $black;
    font-size: 35px;
    font-family: $korean_gd_15_r;
    }
  .input_wrapper {
    flex: 1;
    height: 50px;
    border-style: solid;
    border-width: 1px;
    border-color: #666666;
    padding: 0;
  }
  .input_reset_wrapper {
    background-color: #e6f0fd !important;
    width: 70px;
    height: 33px;
    margin-left: 5px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    padding:0;
    line-height: 0;
    border-style: none;
  }
  .input_reset {
    color: #0840ba;
    font-size: $fs_18;
    font-family: $korean_gd_15_r;
  }

  .md_table {
    border-right-width: 0.5px;
    border-bottom-width: 0.5px;
    border-color: #d6d6d6;
    text-align: center;
    font-size: $fs_13;
  }

  .h_center {
    align-items: center;
  }
  .body{
    display: flex;
    height: 127px;
    padding:15px 15px 25px 15px;
    align-items: center;
  }
  .reg_regist_btn {
    background-color: #ffeb33;
    border-radius: 3px;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    padding: 6px 5px 3px;
    width: 85px;
  }
  .reg_regist_btn_text {color: black; font-size: $fs_18; font-family: $korean_gd_15_r;}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/more/More.vue